import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'highlight';
}
export function Card({
  className,
  variant = 'default',
  children,
  ...props
}: CardProps) {
  const baseStyles = 'rounded-xl overflow-hidden border transition-all duration-300';
  const variants = {
    default: 'bg-slate-900/50 border-slate-800 hover:border-slate-700',
    highlight: 'bg-slate-900 border-orange-500/50 shadow-xl shadow-orange-500/10'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${className || ''}`;
  return <div className={combinedClassName} {...props} data-id="element-75">
      {children}
    </div>;
}